// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueCookie from 'vue-cookie' // https://github.com/alfhen/vue-cookie
import App from './App'
import router from './router'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import { VueEditor } from 'vue2-editor' // QuillJS editor (wrapper)
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'

import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'
import Checklist from './components/Checklist.vue'
import Post from './components/Post.vue'
import NewPost from './components/NewPost.vue'
import ProjectCard from './components/ProjectCard.vue'
import ProjectCardList from './components/ProjectCardList.vue'
import UserTile from './components/UserTile.vue'
import RoleModal from './components/RoleModal.vue'
import EditProjectModal from './components/EditProjectModal.vue'
import ApproveProject from './components/ApproveProject.vue'
import RoleCard from './components/RoleCard.vue'

// Widgets
import EditLink from './components/widgets/EditLink.vue'
import Cropper from './components/widgets/Cropper.vue'

// Components
Vue.component('Nav', Nav)
Vue.component('Footer', Footer)
Vue.component('Checklist', Checklist)
Vue.component('Post', Post)
Vue.component('NewPost', NewPost)
Vue.component('ProjectCard', ProjectCard)
Vue.component('ProjectCardList', ProjectCardList)
Vue.component('UserTile', UserTile)
Vue.component('RoleModal', RoleModal)
Vue.component('EditProjectModal', EditProjectModal)
Vue.component('ApproveProject', ApproveProject)
Vue.component('RoleCard', RoleCard)

// 3rd party libraries
Vue.component('VueEditor', VueEditor)

// Widgets
Vue.component('EditLink', EditLink)
Vue.component('Cropper', Cropper)

Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(Buefy)
Vue.use(VueCookie)
Vue.use(Croppa)

Vue.prototype.$hostname = process.env['VUE_APP_API_URL'];
console.log('Vue is using API at', Vue.prototype.$hostname);

// Vue configuration
// See: https://vuejs.org/v2/api/#Global-Config
Vue.config.productionTip = false

/**
 * LocalStorage - A basic wrapper for storing data in local storage.
 * Automatically handles stringifying and parsing objects based
 * on the key being stored
 */
var LocalStorage = (function() {
    var keys = {
        token: { stringified: false },
        favorites: { stringified: false },
        user: { stringified: false },
        applications: { stringified: false },
    };
    return {
        keys: keys,
        get: function(key) {
            // TODO: error-checking (e.g. key may not exist, parsing may fail)
            var isStringified = keys[key].stringified,
                value = localStorage.getItem(key);

            if(isStringified) return JSON.parse(value);
            return value;
        },
        set: function(key, value) {
            // TODO: error-checking
            var isStringified = keys[key].stringified;
            localStorage.setItem(key, isStringified ? JSON.stringify(value) : value);
        },
        delete: function(key) {
            localStorage.removeItem(key);
        }
    }
})();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App, Nav, Footer, Checklist },
  template: '<App/>',
  data: {
    isLoggedIn: false,
    token: localStorage.getItem('token') || '', // auth token
    user: { // contains logged-in user object
        university: {},
        image: [{
            sizes: {}
        }],
    },
    favorites: [], // if logged-in, contains _array of project ids_ favorited
    applications: [] // if logged-in, contains _array of role applications_ this user has created
  },
  created: function() {
    var that = this;

    // Add an interceptor for when authentication is necessary
    // on a route, so that we can redirect the user to login
    // TODO: still requires redirecting the user after logging (https://stackoverflow.com/questions/45856929/redirect-to-requested-page-after-login-using-vue-router?rq=1)
    Vue.http.interceptors.push(function(request, next) {
        next((response) => {
            // See: https://stackoverflow.com/a/43175433
            if(response.status === 403 && response.body.reason === 'E_NOT_LOGGED_IN') {
                that.destroySession(); // destroy any data associated w/ the session
                that.$router.push({ path: '/login' });
            }
        })
    });

    // Set auth header on each subsequent request
    Vue.http.interceptors.push(function(request, next) {
        request.headers.set('X-AUTH-TOKEN', that.token);
        next();
    });

    if(that.token) {
        // The user has a (possibly valid) login token, so retrieve the
        // information that's saved by this main Vue instance
        // console.log('Already has login token', that.token);

        this.$http.get(this.$hostname + '/me').then(function(response) {
            if(response.body && response.body.id && response.body.username) {
                // Valid login token
                that.isLoggedIn = true;
                that.user = response.body;

                // Get this user's favorite projects and save it to storage
                that.$http.get(that.$hostname + '/user/' + response.body.username + '/favorites').then(function(responseFavorites) {
                    that.favorites = responseFavorites.body.map(function(favoriteProject) {
                        return favoriteProject.id;
                    });
                });

                // Get this user's applications
                that.$http.get(that.$hostname + '/user/applications').then(function(responseApplications) {
                    that.applications = (responseApplications && responseApplications.body) ? responseApplications.body : [];
                });

            }
        });
    }
  },
  methods: {
    dashify: function(str) {
        // Replace whitespace with dashes, and set to lowercase
        // e.g. Puppy Finder App -> puppy-finder-app
        return str.toLowerCase().replace(/\s/gi, '-');
    },
    saveLoginToken: function(token) {
        LocalStorage.set('token', token);
    },
    scrollToTop: function() {
        window.scrollTo(0, 0);
    },
    destroySession: function() {
        // Deletes any data associated with a user session
        this.isLoggedIn = false;
        this.user = {};
        this.favorites = [];
        this.applications = [];

        // Erase token, including local storage
        this.token = '';
        LocalStorage.delete('token');
    },
    logout: function() {
        // Use POST for logout
        // See: https://stackoverflow.com/questions/3521290/logout-get-or-post
        var that = this;
        this.$http.post(this.$hostname + '/logout', {})
        .finally(function() {
          that.destroySession();
          this.$router.push({ path: '/' });
        });
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js